import React, { useEffect, useState } from "react"
import "./DeletedGabs.scss"
import DeletedApi from "Api/DeletedApi"
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { useNavigate } from "react-router-dom"
import { StandardPagination, ActionIcon } from "components/Common"

const DeletedGabs = () => {
  document.title = "Deleted Gabs"

  const accessToken = localStorage.getItem("accessToken")
  const [deletedGabs, setDeletedGabs] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [loading, setLoading] = useState(true)
  const [selectedContent, setSelectedContent] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedGab, setSelectedGab] = useState(null)
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)
  const navigate = useNavigate()

  const getAllDeletedGabs = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    DeletedApi.getAllDeletedGab(config)
      .then(response => {
        setLoading(false)
        setDeletedGabs(response.data.data || [])
        setTotalRecords(response.data.totalDeletedGab || 0)
      })
      .catch(error => {
        setDeletedGabs([])
        setLoading(false)
      })
  }
  const handleViewGab = gab => {
    setSelectedGab(gab)
    setIsDetailsModalOpen(true)
  }

  const toggleDetailsModal = () => {
    setIsDetailsModalOpen(!isDetailsModalOpen)
    if (!isDetailsModalOpen) setSelectedGab(null)
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleContentClick = content => {
    setSelectedContent(content)
    toggleModal()
  }

  useEffect(() => {
    getAllDeletedGabs()
  }, [accessToken, page, limit])

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Deleted", link: "/deleted-gabs" },
    { label: "Deleted Gabs" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const totalPages = Math.ceil(totalRecords / limit)

  const formatDate = dateString => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }
  const renderContent = (contentLink, contentType) => {
    if (!contentLink) {
      return (
        <div className="content-thumbnail">
          <div className="rounded-circle no-content" style={{
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f0f0f0",
            fontSize: "6px",
            textAlign: "center",
            padding: "2px",
            lineHeight: "1",
            wordBreak: "break-word"
          }}>
            No Image or Video
          </div>
        </div>
      )
    }
    return (
      <div
        className="content-thumbnail"
        onClick={() => handleContentClick({ contentLink, contentType })}
      >
        {contentType === "Video" ? (
          <video
            src={contentLink}
            className="rounded-circle"
            width="40"
            height="40"
          />
        ) : (
          <img
            src={contentLink}
            alt="content"
            className="rounded-circle"
            width="40"
            height="40"
          />
        )}
      </div>
    )
  }
  return (
    <div className="deleted-gabs-container">
      <Row>
        <Col xs="12">
          <div className="deleted-gabs-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Deleted Gabs" handleClick={handleBreadcrumbClick} />
          </div>
          <div className="data-table-container">
            <div className="table-responsive">
            {loading ? (
              <DataTableLoader cols={8} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Content</th>
                    <th>Posted By</th>
                    <th>Posted By Type</th>
                    <th>Description</th>
                    <th>Deleted By</th>
                    <th>Deleted On</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedGabs &&
                    deletedGabs.map((gab, index) => (
                      <tr key={gab._id} className="deleted-users-table-row">
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>
                          {renderContent(gab.contentLink, gab.contentType)}
                        </td>
                        <td>{gab.postedBy}</td>
                        <td className="text-capitalize">{gab.postedByType}</td>
                        <td>{gab.description || "-"}</td>
                        <td>{gab.deletedBy?.userName || "-"}</td>
                        <td>{formatDate(gab.deletedOn)}</td>
                        <td>
                          <ActionIcon
                            type="view"
                            onClick={() => handleViewGab(gab)}
                            tooltip="View Gab"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            </div>
          </div>
          <Modal
            isOpen={isModalOpen}
            toggle={toggleModal}
            size="lg"
            centered
          >
            <ModalHeader toggle={toggleModal}>Content Preview</ModalHeader>
            <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
              {selectedContent &&
                (selectedContent.contentType === "Video" ? (
                  <video
                    src={selectedContent.contentLink}
                    controls
                    style={{ width: "100%", height: "400px" }}
                  />
                ) : (
                  <img
                    src={selectedContent.contentLink}
                    alt="content"
                    style={{
                      width: "100%",
                      height: "400px",
                      objectFit: "cover",
                    }}
                  />
                ))}
            </ModalBody>
          </Modal>
          <Modal
            isOpen={isDetailsModalOpen}
            toggle={toggleDetailsModal}
            size="xl"
          >
            <ModalHeader toggle={toggleDetailsModal}>Gab Details</ModalHeader>
            <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
              {selectedGab && (
                <Card>
                  <CardBody>
                    <div className="gab-details">
                      <h5 className="mb-4">Gab Information</h5>
                      <Row className="mb-3">
                        <Col md={12}>
                          <p>
                            <strong>Topic:</strong> {selectedGab.topic || "-"}
                          </p>
                          <p>
                            <strong>Description:</strong>{" "}
                            {selectedGab.description || "-"}
                          </p>
                          <p>
                            <strong>Content Type:</strong>{" "}
                            {selectedGab.contentType}
                          </p>
                          <p>
                            <strong>Categories:</strong>{" "}
                            {selectedGab.category?.join(", ") || "-"}
                          </p>
                          <p>
                            <strong>Tags:</strong>{" "}
                            {selectedGab.tags?.length
                              ? selectedGab.tags.join(", ")
                              : "-"}
                          </p>
                          <p>
                            <strong>Circle:</strong> {selectedGab.circle || "-"}
                          </p>
                          <p>
                            <strong>Gab Score:</strong> {selectedGab.gabScore}
                          </p>
                        </Col>
                      </Row>

                      <h5 className="mb-4">Posting Information</h5>
                      <Row className="mb-3">
                        <Col md={6}>
                          <p>
                            <strong>Posted By:</strong> {selectedGab.postedBy}
                          </p>
                          <p>
                            <strong>Posted By Type:</strong>{" "}
                            {selectedGab.postedByType}
                          </p>
                          <p>
                            <strong>Posted On:</strong>{" "}
                            {formatDate(selectedGab.postedOn)}
                          </p>
                          <p>
                            <strong>Anonymous:</strong>{" "}
                            {selectedGab.isAnonymous ? "Yes" : "No"}
                          </p>
                        </Col>
                      </Row>

                      <h5 className="mb-4">Engagement</h5>
                      <Row className="mb-3">
                        <Col md={6}>
                          <p>
                            <strong>Likes:</strong>{" "}
                            {selectedGab.likes?.length || 0}
                          </p>
                          <p>
                            <strong>Comments:</strong>{" "}
                            {selectedGab.comments?.length || 0}
                          </p>
                        </Col>
                      </Row>

                      <h5 className="mb-4">Deletion Information</h5>
                      <Row>
                        <Col md={12}>
                          <p>
                            <strong>Deleted By:</strong>{" "}
                            {selectedGab.deletedBy?.userName || "-"}
                          </p>
                          <p>
                            <strong>Deleted On:</strong>{" "}
                            {formatDate(selectedGab.deletedOn)}
                          </p>
                          <p>
                            <strong>Deletion Reason:</strong>{" "}
                            {selectedGab.deletedReason || "-"}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              )}
            </ModalBody>
          </Modal>
          <StandardPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </Col>
      </Row>
    </div>
  )
}

export default DeletedGabs
